export default import.meta.ROLLDOWN_FILE_URL_UQ_HJxIs2wfYkqLzpj_TyA